/* eslint-disable prettier/prettier */

import { snakeToCamelTemplateLiterals } from '@/common/converter/utils/snake-to-camel'
import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { convertTitleList } from '@/common/converter/convert-title-list'
import { convertTopButtonList } from '@/common/converter/convert-top-button-list'

/**
 * source object (home) 와 target object (catalog) 을 받아
 * target object 에 source object 를 참조하여 cell property 생성
 * 구 celltop_list 형태를 반환
 * @param source
 * @param target
 * @returns {{blurtarget_img: string, cta: string, bgcolor: string, pagecount: string, count: string, title_list: unknown[]}}
 */
export const convertCellTopList = (source = {}, target = {}) => {
  const { contextProperty } = source
  const topContext = contextProperty?.top

  const cta = topContext?.button ?? ''
  const titleList = topContext?.titleList.map(snakeToCamelTemplateLiterals)
  const blurTargetImg = snakeToCamelTemplateLiterals(topContext?.blurTargetImg)
  const bgImageLandscape = snakeToCamelTemplateLiterals(topContext?.bgImageLandscape)
  const bgColor = snakeToCamelTemplateLiterals(topContext?.bgColor)
  const logoImage = snakeToCamelTemplateLiterals(topContext?.logoImage)
  const count = snakeToCamelTemplateLiterals(topContext?.count)

  return {
    pagecount: '',
    count: replacePlaceholder(count, target) ?? '',
    /** memo: blurTargetImg는 블러와 무관.
    배경 이미지 블러 스펙아웃 되었으나 개발 공수상 서버 응답 필드명 변경하지 않음.
    클라이언트 단에서만 blurtarget_img 대신 bgImage로 사용. **/
    blurtarget_img: replacePlaceholder(blurTargetImg, target) ?? '',
    bgImageLandscape: replacePlaceholder(bgImageLandscape, target) ?? '',
    bgColor: replacePlaceholder(bgColor, target) ?? '',
    logoImage: replacePlaceholder(logoImage, target) ?? '',
    cta,
    title_list: titleList.map((title) => convertTitleList(replacePlaceholder(title, target)) ?? [],),
    topbuttonlist: [convertTopButtonList(source, target)],
  }
}
